import { Component, Inject, ViewChild, ElementRef, OnInit, Input } from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { DialogBase, T4Image, ImageType, User, ComponentBase, PageBase, SystemRights } from 't4core';
import { Router } from '@angular/router';
import { RightsInfo } from 't4core';

export interface RightsInCategory {
    Category: string;
    Rights: [{ Id: string, Name: string, ContainerRight: boolean, EffectiveRight: boolean }];
} 

@Component({
    selector: 'RightsManagementComponent',
    templateUrl: 'RightsManagementComponent.html',
    styleUrls: ['./RightsManagementComponent.css']
})

export class RightsManagementComponent extends ComponentBase {

    @ViewChild("txtUsername", { static: false }) public txtUsername: NgModel;
    @ViewChild("txtEmail", { static: false }) public txtEmail: NgModel;
    @ViewChild("txtMobilePhone", { static: false }) public txtMobilePhone: NgModel;
    @ViewChild("txtcontactPhone", { static: false }) public txtcontactPhone: NgModel;

    //@Input() public user: User;

    private _user: User;
    private _role: any;

    @Input() set role(value: any) {
        this._role = value;
        this.getRights();

    }

    @Input() set user(value: User) {

        this._user = value;
        this.getRights();

    }

    get user(): User {

        return this._user;

    }

    @Input() public editable: boolean = true;
    public allRights: any;
    public myRights: any[] = [];
    public rightsInCategory: RightsInCategory[] = [];

    constructor(el: ElementRef, private router: Router) {
        super();
    }

    public async ngOnInit() {

    }

    public async getRights() {
        var token = this.UI.beginLoading("T4.Settings.ManageRights.msgLoading", "Loading rights", null);

        var id = this._user ? this._user.Username : this._role.Id;

      this.allRights = await this.Api.get<any>("Account/GetRights", { id: id, isRole: this._user ? false : true });
  
        this.rightsInCategory = [];
        for (let right of this.allRights) {
            var rights = { Id: right.Item1.Id, Name: right.Item1.Name, ContainerRight: right.Item1.Value, EffectiveRight: right.Item2 };

            var index = this.rightsInCategory.findIndex(x => x.Category == right.Item1.Category);
            if (index > -1) {
                this.rightsInCategory[index].Rights.push(rights);
            }
            else {
                var category: RightsInCategory = {
                    Category: right.Item1.Category,
                    Rights: [rights],
                }
                this.rightsInCategory.push(category);
            }
        }
    

        this.UI.loaderCompleted(token);

    }

    public async updateRightValue(right: string, selection: any) {
        var id = this._user ? this._user.Username : this._role.Id;
        var token = this.UI.beginLoading("T4.Settings.ManageSettings.msgSavingSetting", "Saving setting", null);
        var success = await this.Api.get<any>("Account/SetRight", { right: right, id: id, isRole: this._user ? false : true, value: selection.value });
        this.UI.loaderCompleted(token);

        await this.getRights();

        if (!success) {
            this.UI.alert("Turbo.Settings.EditUserComponent.Save.titleFailed", "Failed!", "Turbo.Settings.EditUserComponent.Save.msgFailed", "The settings could not be saved.");
        }
    }

    public async getUserInfo() {
        if (this._user) {
            var token = this.UI.beginLoading("T4.Settings.ManageSettings.msgLoadingUser", "Loading user", null);
            this._user = await this.Api.get("Account/GetInfoForOtherUser", { userName: this._user.Username });
            this.UI.loaderCompleted(token);

            if (!this.user) {
                this.UI.alert("Turbo.Settings.EditUserComponent.titleUserNotFound", "Not found!", "Turbo.Settings.EditUserComponent.msgUserNotFound", "No user was found.");
            }
        }
    }

    public async save() {
        var token = this.UI.beginLoading("T4.Settings.ManageCategories.msgLoading", "Loading categories", null);
        var success = await this.Api.post("Account/EditOtherUserInfo", null, { userName: this.user.Username, email: this.user.Email, phone: this.user.Phone });
        this.UI.loaderCompleted(token);

        if (!success) {
            this.UI.alert("Turbo.Settings.EditUserComponent.Save.titleFailed", "Failed!", "Turbo.Settings.EditUserComponent.Save.msgFailed", "The settings could not be saved.");
        }
        else {
            this.UI.alert("Turbo.Settings.EditUserComponent.Save.titleSuccess", "Settings saved!", "Turbo.Settings.EditUserComponent.Save.msgSuccess", "The settings have been saved.");
        }
    }
}
